<template>
  <div class=" pd-20 pd-lg-25 pd-xl-30">
    <div class="card card-profile card-event">
      <img src="assets/img/covers/4.png" alt class="card-img-top" />
      <div class="card-body tx-13 pd-y-10-f">
        <div class="avatar avatar-xxl mt-n80px wd-140 ht-140">
          <img
            :src="`${task.defaultAttachmentUrl}?w=144&h=144&mode=pad`"
            alt
            class="rounded-circle img-thumbnail border-0 pd-0-f"
          />
        </div>
        <div class="ht-120 align-items-start mg-l-150 pd-l-10 pd-t-20">
          <h6>
            <a>{{ task.taskEn }} {{ task.task }}</a>
          </h6>
          <p class="mg-b-2 text-muted">Газар нэгж: {{ task.st1 }}</p>
          <p class="mg-b-2 text-muted">Албан тушаал: {{ task.position }}</p>
          <p class="mg-b-0 text-muted">И-мэйл хаяг: {{ task.st2 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style></style>
